import { HomeResident } from 'src/models/resort/HomeResident';
import { HouseType } from 'src/models/resort/HouseType';

// 別荘の住民がが例外処理が必要な「かっぺいファミリー」か「エイブルシスターズ」かを判定する関数
// ツクッターでは、別荘に住んでいる住民の名前や顔画像を表示する。
// 一部の特殊NPCが住民である場合、これらの表示について例外的な対応をする必要がある
// 詳しくは仕様ページを参照：https://spdlybra.nintendo.co.jp/confluence/pages/viewpage.action?pageId=1171659946
export function getHouseType(npcs: HomeResident[]): HouseType {
  if (
    npcs.length === 2 &&
    npcs[0].npcType === 2 &&
    npcs[0].npcId === 16 &&
    npcs[1].npcType === 2 &&
    npcs[1].npcId === 15
  ) {
    return 'kappei-family';
  } else if (
    npcs.length === 2 &&
    npcs[0].npcType === 2 &&
    npcs[0].npcId === 13 &&
    npcs[1].npcType === 2 &&
    npcs[1].npcId === 12
  ) {
    return 'able-sisters';
  } else {
    return 'normal';
  }
}
